import { render } from "./ComprasPago.vue?vue&type=template&id=74f9f329"
import script from "./ComprasPago.vue?vue&type=script&lang=js"
export * from "./ComprasPago.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/gastos/ComprasPago.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "74f9f329"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('74f9f329', __exports__)) {
    api.reload('74f9f329', __exports__)
  }
  
  module.hot.accept("./ComprasPago.vue?vue&type=template&id=74f9f329", () => {
    api.rerender('74f9f329', render)
  })

}


export default __exports__